__turbopack_context__.v({
  "pageWrapper": "IndiaPerformanceLabsPage-module__FezWfG__pageWrapper",
});
